<template>
  <div class="row">
    <div class="col-md-6">
      <div class="card">
        <img class="m-4" :src="'image-service:/production/56d032a155699.jpg' | image">

        <div class="card-body">
          <select v-model="width" class="custom-select" @change="onChange">
            <option v-for="(selectOption, index) in widthOptions" :key="index" :value="selectOption" :selected="selectOption === selectedOption.width">
              {{ selectOption }} {{ step.unit }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <img class="m-4" :src="'image-service:/production/56d0329d35428.jpg' | image">

        <div class="card-body">
          <select v-model="height" class="custom-select" @change="onChange">
            <option v-for="(selectOption, index) in heightOptions" :key="index" :value="selectOption" :selected="selectOption === selectedOption.height">
              {{ selectOption }} {{ step.unit }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
// import DimensionOption from './dimensionOption'

export default {
  data: () => ({
    height: 0,
    width: 0,
    currentType: 'width'
  }),
  computed: {
    selectedOption () {
      return this.step.options.find(o => o.selected)
    },
    relevantOptions () {
      return this.step.options.filter(o => {
        return (o.height === this.height || o.width === this.width) && o.height > 0 && o.width > 0
      })
    },
    widthOptions () {
      return _.uniq(this.relevantOptions.map(o => o.width).sort((a, b) => a - b))
    },
    heightOptions () {
      return _.uniq(this.relevantOptions.map(o => o.height).sort())
    },
    ...mapGetters({
      step: 'configurator/currentStep'
    })
  },
  mounted () {
    this.width = this.selectedOption.width
    this.height = this.selectedOption.height
  },
  methods: {
    ...mapActions({
      selectDimensionTable: 'configurator/selectDimensionTable'
    }),
    onChange (...args) {
      this.selectDimensionTable({ height: this.height, width: this.width })
    }
  }
}
</script>
